import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Typography } from "@mui/material";

export default function PerPage({ limit, setLimit }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onSelect = (val) => {
    setLimit(val);
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        size="small"
        id="per-page"
        aria-haspopup="true"
        onClick={handleClick}
        sx={{ minWidth: 40, fontSize: 10 }}
        aria-expanded={open ? "true" : undefined}
        aria-controls={open ? "per-page-menu" : undefined}
        endIcon={
          <Typography
            width={32}
            height={24}
            borderRadius={2}
            bgcolor="background.paper"
            variant="subtitle1"
            fontSize={10}
            p={0.5}
            lineHeight={1}
          >
            {limit}
          </Typography>
        }
      >
        {`تعداد در صفحه`}
      </Button>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        id="per-page-menu"
        slotProps={{
          list: {
            "aria-labelledby": "per-page",
          },
        }}
      >
        <MenuItem dense onClick={() => onSelect(6)}>
          06
        </MenuItem>
        <MenuItem dense onClick={() => onSelect(12)}>
          12
        </MenuItem>
        <MenuItem dense onClick={() => onSelect(24)}>
          24
        </MenuItem>
      </Menu>
    </div>
  );
}
